import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
export const CommonFormStyle = {
    formStyle: {
        default: {},
        retro: {},
        electric: {}
    }
}


// WEBPACK FOOTER //
// ./src/components/User/UserForm/style/UserForm.js